import { Component, Inject, OnInit, ViewChild, Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DatePipe } from '@angular/common';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  displayedColumns: string[] = ['Time', 'LogLevel', 'UserId', 'FacilityID', 'Action', 'Message'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort, { static: true }) sort: MatSort;


  singleLogViewer: boolean = false;


  timevalue;

  LogData;
  OrginalLogData;

  macId = "NA";
  deviceId = "NA";
  appVersion = "NA";
  appId = "NA";
  EMROperator = "NA";


  info;
  warning;
  debug;
  error;
  apihit;

  panelOpenState = false;
  selectedFiles: File[];

  ngOnInit() {
    this.dataSource.sort = this.sort;
  }

  public fileContent: string;

  // I initialize the app component.
  constructor() {
    this.fileContent = "";
    this.LogData = [];
    this.OrginalLogData = [];

    this.info = 0;
    this.warning = 0;
    this.debug = 0;
    this.error = 0;
    this.apihit = 0;

  }

  // ---
  // PUBLIC METHODS.
  // ---

  // I get called whenever change detection is triggered on this component.
  // --
  // NOTE: We are logging this in order to make sure that the MASSIVE NUMBER of drag
  // and drop events are not triggering unnecessary change-detection in the app.
  public ngDoCheck(): void {

    console.log("App component ngDoCheck()");


  }

  openGroup(fileReceived) {
    console.log(fileReceived);
  }

  onFileReceived(value) {

    this.renderFileContent(value.toString());

  }


  onMultipleFileSelected(files: File[]) {
    console.clear();
    console.log('Multiple Selected Files');
    console.log(files);
    this.selectedFiles = files;

  }

  // When the user drops a text-file on the file-drop component, it will emit the
  // file-content as an event. I render the emitted file-content to the view.
  public renderFileContent(value: string): void {

    //this.fileContent = value;



    console.log('fileValues');

    var arrayList = value.split('\n');

    var position = 1;

    arrayList.forEach(log => {


      // 2019-11-22T03:17:49-42:42 LogLevel="DEBUG"
      // macId="b4:ce:f6:9d:fb:c2" deviceId="c21b18248ad66be7"
      //appVersion="8.00.05" appId="RC2.0" userId="NA"
      // EMROperator="NA" FacID="NA" action="GET" message="Login Page Token Receiving"

      var datetime = log.substring(0, 25);

      var loglevel = this.getLogValue(log, "LogLevel", "macId");

      if (this.equalIgnorecase(loglevel, "DEBUG")) {
        this.debug++;
      } else if (this.equalIgnorecase(loglevel, "INFO")) {
        this.info++;
      } else if (this.equalIgnorecase(loglevel, "ERROR")) {
        this.error++;
      } else if (this.equalIgnorecase(loglevel, "WARNING")) {
        this.warning++;
      }


      var macId = this.getLogValue(log, "macId", "deviceId");
      var deviceId = this.getLogValue(log, "deviceId", "appVersion");
      var appVersion = this.getLogValue(log, "appVersion", "appId");
      var appId = this.getLogValue(log, "appId", "userId");
      var EMROperator = this.getLogValue(log, "EMROperator", "FacID");

      if (macId !== undefined || macId !== null) {
        this.macId = macId;
      }
      if (deviceId !== undefined || deviceId !== null) {
        this.deviceId = deviceId;
      }
      if (appVersion !== undefined || appVersion !== null) {
        this.appVersion = appVersion;
      }

      if (appId !== undefined || appId !== null) {
        this.appId = appId;
      }

      if (deviceId !== undefined || deviceId !== null) {
        this.EMROperator = EMROperator;
      }

      var userId = this.getLogValue(log, "userId", "EMROperator").toString();
      var FacID = this.getLogValue(log, "FacID", "action");
      var action = this.getLogValue(log, "action", "message");


      if (this.equalIgnorecase(action, "API URL")) {
        this.apihit++;
      }

      var message = log.substring(log.indexOf("message=\"") + 9, log.length - 1)


      console.log(userId);

      var timevalue: string = datetime.split('T')[1];


      console.log(timevalue);

      if (timevalue != undefined) {
        this.LogData.push(
          {
            'no': position,
            'datetime': datetime,
            'time': timevalue.substring(0, 8),
            'loglevel': loglevel,
            'userId': userId,
            'FacID': FacID,
            'action': action,
            'message': message,

          }
        );

        position++;
      }
    });


    this.OrginalLogData = this.LogData;
    console.log(this.LogData.length);

  }
  public equalIgnorecase(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b;
  }

  showOnlyINFO() {

    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "INFO") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyWARNING() {

    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "WARNING") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyERROR() {

    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "ERROR") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }
  showOnlyDEBUG() {

    var filterData = [];
    this.OrginalLogData.forEach(log => {

      if (log.loglevel === "DEBUG") {
        filterData.push(log);
      }
    });

    this.LogData = filterData;
  }

  showOnlyShowALL() {
    this.LogData = this.OrginalLogData;

  }

  public getLogValue(logdata: string, startColumn: string, endColumn: string): string {
    var startIndex = logdata.indexOf(startColumn + "=\"") + startColumn.length;
    var endIndex = logdata.indexOf(endColumn + "=\"") - 1;

    if (startIndex === -1 || endIndex === -1) {
      return "NA";
    }
    var loglevel = logdata.substring(startIndex + 2, endIndex - 1).trim();

    return loglevel;
  }


  // When the user clicks on div, open the popup
  public myFunction() {
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }

  countData: any = {};

  onCountsReceived(counts) {

    console.log('Counts Received');
    console.log(counts);
    this.countData = counts;

   
    this.countData[counts.name] = {
      warning: String(counts.warning),
      error: String(counts.error),
      total: String(counts.total),
    };

  console.log('After Data Inserted');
    console.log(this.countData);

  }




}


